import React, { Component } from "react";
import { Div, Button } from "glamorous";
import YouTube from "react-youtube";
import Spinner from "./../common/Spinner";
import styles from "../../styles";

const videoId = "_eyfz4sJiMQ";

class TutorialVideo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ready: false,
      playing: false
    };

    this.playerOpts = {
      height: "100%",
      width: "100%",
      playerVars: {
        controls: 0,
        showinfo: 0,
        modestbranding: 1,
        autoplay: 1,
        playsinline: 1
      }
    };
  }

  render() {
    return (
      <Div css={styles.video.wrapper}>
        <Div
          css={styles.video.frameWrapper}
          style={{ background: this.state.playing ? "none" : "" }}
        >
          <Button
            onClick={() => {
              this.props.setArea("Landing");
            }}
            css={styles.video.closeButton}
          />
          {!this.state.playing ? (
            <Div css={styles.video.playWrapper}>
              {this.state.ready ? (
                <Button
                  css={styles.video.playButton}
                  onClick={() => this.handlePlay()}
                  style={{ opacity: this.state.ready ? 1 : "" }}
                />
              ) : (
                <Spinner />
              )}
            </Div>
          ) : null}
          <Div
            height="100%"
            width="100%"
            css={{ display: this.state.playing ? "block" : "none" }}
          >
            <YouTube
              videoId={videoId}
              onReady={evt => this.handleReady(evt)}
              onStateChange={evt => this.handlePlayerState(evt)}
              opts={this.playerOpts}
            />
          </Div>
        </Div>
      </Div>
    );
  }

  handleReady(evt) {
    this.player = evt.target;
    this.setState({ ready: true });
  }

  handlePlayerState(evt) {
    if (!this.state.playing && evt.data === YouTube.PlayerState.PLAYING) {
      this.setState({ playing: true });
    } else if (evt.data === YouTube.PlayerState.ENDED) {
      this.player.seekTo(0);
      this.player.playVideo();
    }
  }

  handlePlay() {
    this.player.playVideo();
    this.setState({ playing: true });
  }
}

export default TutorialVideo;



// WEBPACK FOOTER //
// ./src/components/areas/TutorialVideo.js